export default __webpack_public_path__ + "static/media/slots-icons-terraluna.3a0a4f89.png";